import React from 'react';

import { Text } from './Text';

import { cn } from 'domain/core';
import type { LinkProps } from './common-types';

export const Link = React.forwardRef((props: LinkProps, ref: any) => {
  const { className, ...rest } = props;
  return (
    <a
      className={cn(
        'link',
        'text-primary-600 no-underline',
        'hover:underline',
        className
      )}
      ref={ref}
      {...rest}
    />
  );
});

type AutolinkProps = Omit<LinkProps, 'href'> & { linkClassName?: string };
/**
 * Component that receives text and extracts from the text those strings that match the form of a link. Renders these matches as a Link.
 */
export const Autolink = React.forwardRef((props: AutolinkProps, ref: any) => {
  const {
    className,
    linkClassName,
    children,
    key,
    target = '_blank',
    rel = 'noopener noreferrer',
    ...rest
  } = props;

  const text = typeof children === 'string' ? children : '';

  const delimiter = /(https?:\/\/[^\s]+)/gi;

  return (
    <Text className={className} ref={ref} key={key}>
      {text.split(delimiter).map((word, index) => {
        let match = word.match(delimiter);
        if (match) {
          let url = match[0];
          return (
            <Link
              className={linkClassName}
              key={url}
              target={target}
              rel={rel}
              href={url.startsWith('http') ? url : `http://${url}`}
              {...(rest as any)}
            >
              {url}
            </Link>
          );
        }
        return word;
      })}
    </Text>
  );
});
